export default __webpack_public_path__ + "static/media/treinKlein.c72500b0.jpg";